import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

// Components
import { SelectInput } from 'components/forms/form-elements';


function CompanySelect({ companies, options, ...props }) {
  const optionCompanies = options || companies;

  _.forEach(optionCompanies, (company) => {
    company.label = `${company.nickname} - ${company.name}`;
  });

  return (
    <SelectInput
      {..._.omit(props, 'dispatch')}
      isLoading={!optionCompanies}
      options={optionCompanies}
      valueKey="id"
      labelKey="label"
      matchProp="label"
      optionRenderer={renderMenuOption}
    />
  );
}

CompanySelect.propTypes = {
  companies: PropTypes.array,
  options: PropTypes.array
};

export default connect((state) => ({ companies: state.pageData.selectCompanies }))(CompanySelect);


function renderMenuOption(company) {
  if (company.nickname === company.name) return <span>{company.name}</span>;

  return (
    <span>
      {company.nickname}
      <span className="deemphasize"> - {company.name}</span>
    </span>
  );
}



// WEBPACK FOOTER //
// ./app/components/forms/selects/company-select.js